"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getElementByHook(element, hook) {
    return element.querySelector("[data-playable-hook=\"".concat(hook, "\"]"));
}
exports.default = getElementByHook;
//# sourceMappingURL=getElementByHook.js.map